// Endpoints da Jornada de Configuração (Fase 2 — backend real).
// `get` carrega a jornada (tarefas + status curados). `markTask` marca/desmarca
// uma etapa manualmente (reversível) — o status vem do backend, o front não calcula.
// O nível do escritório NÃO tem endpoint de escrita: a progressão é 100%
// automática (2026-07-29) e o backend re-resolve o ponteiro a cada `get`.
export const configJourney = {
  get: () => '/v3/api/config-journey',
  markTask: () => '/v3/api/config-journey/mark-task',
}
